import { PermissionLevel, PermissionLevelsCatalog } from '../types/permissions';
import { UserRoles } from '../types/user-roles';

export const permissionLevelsCatalog: PermissionLevelsCatalog = {
  [PermissionLevel.FULL_ACCESS]: [UserRoles.OWNER],
  [PermissionLevel.EDITOR]: [UserRoles.OWNER, UserRoles.ADMIN, UserRoles.MANAGER],
  [PermissionLevel.VIEWER]: [
    UserRoles.OWNER,
    UserRoles.ADMIN,
    UserRoles.MANAGER,
    UserRoles.SALESPERSON,
    UserRoles.USER,
  ],
};
